import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class ConfigApi{
    static baseUrl = appConfig.gatewayUrl+appConfig.appointmentServicePath;
    // static baseUrl = "http://localhost:20065/appointment-service" ;

    static getConfig(param){
        return httpGet(this.baseUrl + "/config", param)
    }
}